module.exports = __webpack_public_path__ + "img/3.49c96074.jpg";